import { apiBase } from "../api.config";

// 圖片上傳
export const apiImage = (data, token) =>
  apiBase.post("/api/image", data, token);

// 登入驗證
export const LoginCms = {
  login: data => apiBase.post("/api/vendor/auth", data),
  confirm: data => apiBase.post("/api/vendor/auth/confirm", data),
  permission: token => apiBase.get("/api/vendor/auth/permission", token),
  user: token => apiBase.get("/api/vendor/auth/user", token)
};

export const Product = {
  get: (id, token) => apiBase.get(`/api/vendor/product/${id || ""}`, token),
  create: (data, token) => apiBase.post("/api/vendor/product", data, token),
  update: (id, data, token) =>
    apiBase.put(`/api/vendor/product/${id}`, data, token),
  status: (id, status, token) =>
    apiBase.patch(`/api/vendor/product/${id}`, status, token),
  getTag: token => apiBase.get("/api/vendor/tags", token),
  getBrand: token => apiBase.get("/api/vendor/brand", token),
  getModel: (brandID, token) =>
    apiBase.get(`api/vendor/brand/${brandID}/model`, token),
  getType: (brandID, modelID, token) =>
    apiBase.get(`api/vendor/brand/${brandID}/model/${modelID}/type`, token),
  getCategory: token => apiBase.get("/api/category", token),
  delete: (id, token) =>
    apiBase.delete(`/api/vendor/product/${id || ""}`, token)
};

export const Zone = {
  get: (id, token) => apiBase.get(`/api/vendor/zone/${id || ""}`, token),
  create: (data, token) => apiBase.post("/api/vendor/zone", data, token),
  update: (id, data, token) =>
    apiBase.put(`/api/vendor/zone/${id}`, data, token),
  delete: (id, token) => apiBase.delete(`/api/vendor/zone/${id}`, token)
};

export const Account = {
  get: (id, token) => apiBase.get(`/api/vendor/account/${id || ""}`, token),
  create: (data, token) => apiBase.post("/api/vendor/account", data, token),
  update: (id, data, token) =>
    apiBase.put(`/api/vendor/account/${id}`, data, token),
  status: (id, status, token) =>
    apiBase.patch(`/api/vendor/account/${id}`, status, token),
  delete: (id, token) => apiBase.delete(`/api/vendor/account/${id}`, token)
};

export const Order = {
  get: (id, token) => apiBase.get(`/api/vendor/order/${id || ""}`, token),
  update: (id, data, token) =>
    apiBase.put(`/api/vendor/order/${id}`, data, token),
  assign: (id, assign, token) =>
    apiBase.post(`/api/vendor/order/${id}/assign`, assign, token)
};

export const Notify = {
  get: token => apiBase.get("/api/notify", token),
  read: (uuid, token) => apiBase.put(`/api/notify/${uuid}`, "", token),
  saveToken: (firebaseToken, token) =>
    apiBase.post("/api/notify/save-token", firebaseToken, token)
};

export const Report = {
  order: (data, token) => apiBase.post("/api/vendor/order/report", data, token),
  part: (data, token) => apiBase.post("/api/vendor/part/report", data, token),
  get: (reportId, token) =>
    apiBase.get(`/api/vendor/report/download/${reportId}`, token)
};
